module.exports = __webpack_public_path__ + "static/media/DocumentTagged.bc672807.svg";